<template>
  <div class="error-404">
    <img src="@/assets/img/404.png" alt="404">
    <h3>
      <a href="/">当前页面似乎受到三体射线的干扰，点此返回首页</a>
    </h3>
  </div>
</template>

<script>
export default {
  name: 'Error404',
  methods: {
    backPage () {
      this.$router.go(-1)
    },
    goHome () {
      this.$router.push({ path: '/' })
    }
  }
}
</script>

<style lang="scss" scoped>
  .error-404 {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    text-align: center;
    a {
      font-size: 18px;
      color: #979dac;
      margin-top: 20px;
    }
  }
</style>
